import { type AvailableCountry, type Validation } from '@/models';

import { dkValidation } from './DK';
import { noValidation } from './NO';
import { seValidation } from './SE';

export type FieldName =
  | 'phoneNumber'
  | 'email'
  | 'accountNumber'
  | 'trusteeName'
  | 'trusteePhone'
  | 'withdrawalAmount'
  | 'withdrawalDate'
  | 'accountPrefix';

export const validations = {
  DK: dkValidation,
  NO: noValidation,
  SE: seValidation,
} satisfies Record<AvailableCountry, Record<FieldName, Validation>>;
